class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      // Prüfe, ob der Klick auf den SVG-Wrapper oder das SVG-Icon selbst erfolgt ist
      const clickedElement = event.target;
      const svgWrapper = clickedElement.closest('.svg-wrapper');
      const svgIcon = clickedElement.closest('svg');
      
      // Nur ausführen, wenn auf den SVG-Wrapper oder das SVG-Icon geklickt wurde
      if (!svgWrapper && !svgIcon && !clickedElement.matches('.svg-wrapper') && !clickedElement.matches('svg')) {
        return; // Ignoriere den Klick, wenn nicht auf das Icon geklickt wurde
      }
      
      event.preventDefault();
      event.stopPropagation();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      if (cartItems) {
      cartItems.updateQuantity(this.dataset.index, 0, event);
      }
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');
    this.configurationGroupExpandedState = window.__cartConfigGroupExpandedState || {};
    window.__cartConfigGroupExpandedState = this.configurationGroupExpandedState;

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
    this.addEventListener('click', this.onConfigurationToggleClick.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      return this.onCartUpdate();
    });
    if (this.tagName === 'CART-ITEMS' && typeof window.syncKonfiguratorOrderNote === 'function') {
      setTimeout(() => window.syncKonfiguratorOrderNote(), 600);
    }
    this.applySavedConfigurationGroupStates();
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = '';

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        event,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  onConfigurationToggleClick(event) {
    const quantityButton = event.target.closest('.js-cart-config-quantity-button');
    if (quantityButton && this.contains(quantityButton)) {
      event.preventDefault();
      event.stopPropagation();
      this.updateConfigurationGroupQuantity(quantityButton);
      return;
    }

    const removeButton = event.target.closest('.js-cart-config-remove');
    if (removeButton && this.contains(removeButton)) {
      event.preventDefault();
      event.stopPropagation();
      this.removeConfigurationGroup(removeButton);
      return;
    }

    const toggleButton = event.target.closest('.js-cart-config-toggle');
    if (!toggleButton || !this.contains(toggleButton)) {
      return;
    }

    event.preventDefault();
    this.toggleConfigurationGroup(toggleButton);
  }

  toggleConfigurationGroup(toggleButton) {
    const configGroup = toggleButton.dataset.configGroup;
    if (!configGroup) {
      return;
    }

    const isExpanded = toggleButton.getAttribute('aria-expanded') !== 'false';
    const shouldExpand = !isExpanded;
    toggleButton.setAttribute('aria-expanded', String(shouldExpand));
    this.setConfigurationGroupExpandedState(configGroup, shouldExpand);

    const escapedConfigGroup =
      typeof CSS !== 'undefined' && typeof CSS.escape === 'function'
        ? CSS.escape(configGroup)
        : configGroup.replace(/["\\]/g, '\\$&');
    const groupItems = this.querySelectorAll(`.cart-item--config-group[data-config-group="${escapedConfigGroup}"]`);

    for (const groupItem of groupItems) {
      groupItem.classList.toggle('cart-item--config-collapsed', !shouldExpand);
    }
  }

  setConfigurationGroupExpandedState(configGroup, isExpanded) {
    if (!configGroup) {
      return;
    }
    this.configurationGroupExpandedState[String(configGroup)] = Boolean(isExpanded);
  }

  applySavedConfigurationGroupStates(scope = document) {
    const toggles = scope.querySelectorAll ? scope.querySelectorAll('.js-cart-config-toggle') : [];
    for (const toggleButton of toggles) {
      const configGroup = toggleButton.dataset.configGroup;
      if (!configGroup) {
        continue;
      }

      const key = String(configGroup);
      const shouldExpand =
        Object.prototype.hasOwnProperty.call(this.configurationGroupExpandedState, key)
          ? this.configurationGroupExpandedState[key]
          : true;
      toggleButton.setAttribute('aria-expanded', String(shouldExpand));

      const escapedConfigGroup =
        typeof CSS !== 'undefined' && typeof CSS.escape === 'function'
          ? CSS.escape(configGroup)
          : configGroup.replace(/["\\]/g, '\\$&');
      const groupItems = scope.querySelectorAll(
        `.cart-item--config-group[data-config-group="${escapedConfigGroup}"]`
      );
      for (const groupItem of groupItems) {
        groupItem.classList.toggle('cart-item--config-collapsed', !shouldExpand);
      }
    }
  }

  async updateConfigurationGroupQuantity(quantityButton) {
    const quantityWrapper = quantityButton.closest('.js-cart-config-quantity');
    if (!quantityWrapper) {
      return;
    }

    const configGroup = quantityWrapper.dataset.configGroup;
    if (!configGroup) {
      return;
    }

    const action = quantityButton.dataset.action;
    const currentQuantity = parseInt(quantityWrapper.dataset.configQuantity || '1', 10);
    const safeCurrentQuantity = Number.isNaN(currentQuantity) || currentQuantity < 1 ? 1 : currentQuantity;
    const nextQuantity = action === 'decrease' ? Math.max(1, safeCurrentQuantity - 1) : safeCurrentQuantity + 1;
    if (nextQuantity === safeCurrentQuantity) {
      return;
    }

    const quantityButtons = quantityWrapper.querySelectorAll('.js-cart-config-quantity-button');
    for (const button of quantityButtons) {
      button.disabled = true;
    }

    const cartItemsContainer = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    if (cartItemsContainer) {
      cartItemsContainer.classList.add('cart__items--disabled');
    }

    try {
      const cartResponse = await fetch(`${routes.cart_url}.js`);
      const cart = await cartResponse.json();
      const updates = {};

      for (const item of cart.items || []) {
        const configurationNumber = item.properties && item.properties['Konfiguration'];
        if (String(configurationNumber) !== String(configGroup)) {
          continue;
        }

        const fallbackFactor = Math.max(1, Math.round((item.quantity || safeCurrentQuantity) / safeCurrentQuantity));
        updates[item.key] = fallbackFactor * nextQuantity;
      }

      if (Object.keys(updates).length === 0) {
        return;
      }

      const updatedNote = this.updateConfigurationQuantityInNote(cart.note, configGroup, nextQuantity);
      const parsedState = await this.submitCartUpdates(updates, { note: updatedNote });
      if (!parsedState) {
        return;
      }

      this.applyParsedCartStateSections(parsedState);
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState });

    } catch (error) {
      console.error(error);
    } finally {
      if (cartItemsContainer) {
        cartItemsContainer.classList.remove('cart__items--disabled');
      }
    }
  }

  async removeConfigurationGroup(removeButton) {
    const configGroup = removeButton.dataset.configGroup;
    if (!configGroup) {
      return;
    }

    removeButton.disabled = true;
    const cartItemsContainer = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    if (cartItemsContainer) {
      cartItemsContainer.classList.add('cart__items--disabled');
    }

    try {
      const cartResponse = await fetch(`${routes.cart_url}.js`);
      const cart = await cartResponse.json();
      const updates = {};

      for (const item of cart.items || []) {
        const configurationNumber = item.properties && item.properties['Konfiguration'];
        if (String(configurationNumber) === String(configGroup)) {
          updates[item.key] = 0;
        }
      }

      if (Object.keys(updates).length === 0) {
        return;
      }

      const updatedNote = this.removeConfigurationFromNote(cart.note, configGroup);
      const parsedState = await this.submitCartUpdates(updates, { note: updatedNote });
      if (!parsedState) {
        return;
      }

      this.applyParsedCartStateSections(parsedState);
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState });

    } catch (error) {
      console.error(error);
    } finally {
      if (cartItemsContainer) {
        cartItemsContainer.classList.remove('cart__items--disabled');
      }
    }
  }

  async submitCartUpdates(updates, extraPayload = {}) {
    const sections = this.getSectionsToRender()
      .map((section) => section.section)
      .filter(Boolean);
    const body = JSON.stringify({
      updates,
      sections,
      sections_url: window.location.pathname,
      ...extraPayload,
    });

    const response = await fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
    const state = await response.text();
    return JSON.parse(state);
  }

  updateConfigurationQuantityInNote(note, configGroup, nextQuantity) {
    if (!note || !String(note).trim()) {
      return note || '';
    }

    const separator = '═════════════════════\nKONFIGURATION ';
    const parts = String(note).split(separator);
    if (parts.length < 2) {
      return note;
    }

    const prefix = (parts[0] || '').trim();
    const blocks = [];

    for (let i = 1; i < parts.length; i += 1) {
      let block = (parts[i] || '').replace(/^\s+|\s+$/g, '');
      const firstLineEnd = block.indexOf('\n');
      const firstLine = firstLineEnd === -1 ? block : block.slice(0, firstLineEnd).trim();
      const blockNum = parseInt(firstLine, 10);

      if (!Number.isNaN(blockNum) && String(blockNum) === String(configGroup)) {
        if (/^Anzahl:\s.*$/m.test(block)) {
          block = block.replace(/^Anzahl:\s.*$/m, `Anzahl: ${nextQuantity}`);
        }
      }

      blocks.push(separator + block);
    }

    if (prefix) {
      return [prefix, ...blocks].join('\n\n');
    }

    return blocks.join('\n\n');
  }

  removeConfigurationFromNote(note, configGroup) {
    if (!note || !String(note).trim()) {
      return note || '';
    }

    const separator = '═════════════════════\nKONFIGURATION ';
    const parts = String(note).split(separator);
    if (parts.length < 2) {
      return note;
    }

    const prefix = (parts[0] || '').trim();
    const blocks = [];

    for (let i = 1; i < parts.length; i += 1) {
      const block = (parts[i] || '').replace(/^\s+|\s+$/g, '');
      const firstLineEnd = block.indexOf('\n');
      const firstLine = firstLineEnd === -1 ? block : block.slice(0, firstLineEnd).trim();
      const blockNum = parseInt(firstLine, 10);

      if (!Number.isNaN(blockNum) && String(blockNum) === String(configGroup)) {
        continue;
      }

      blocks.push(separator + block);
    }

    if (prefix && blocks.length > 0) {
      return [prefix, ...blocks].join('\n\n');
    }

    if (prefix && blocks.length === 0) {
      return prefix;
    }

    return blocks.join('\n\n');
  }

  applyParsedCartStateSections(parsedState) {
    if (!parsedState || !parsedState.sections) {
      return;
    }

    this.classList.toggle('is-empty', parsedState.item_count === 0);
    const cartDrawerWrapper = document.querySelector('cart-drawer');
    const cartFooter = document.getElementById('main-cart-footer');

    if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
    if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

    this.getSectionsToRender().forEach((section) => {
      const sectionHtml = parsedState.sections[section.section];
      const rootElement = document.getElementById(section.id);
      if (!sectionHtml || !rootElement) {
        return;
      }

      const elementToReplace = section.selector ? rootElement.querySelector(section.selector) || rootElement : rootElement;
      elementToReplace.innerHTML = this.getSectionInnerHTML(sectionHtml, section.selector);
    });

    this.applySavedConfigurationGroupStates(document);
  }

  async refreshCartIconBubble() {
    const cartIconElement = document.getElementById('cart-icon-bubble');
    if (!cartIconElement) {
      return;
    }

    const response = await fetch(`${routes.cart_url}?section_id=cart-icon-bubble`);
    const responseText = await response.text();
    const html = new DOMParser().parseFromString(responseText, 'text/html');

    const sourceIconElement = html.querySelector('#cart-icon-bubble');
    if (sourceIconElement) {
      cartIconElement.innerHTML = sourceIconElement.innerHTML;
      return;
    }

    const sourceSectionElement = html.querySelector('div[id*="shopify-section-cart-icon-bubble"], .shopify-section');
    if (sourceSectionElement) {
      cartIconElement.innerHTML = sourceSectionElement.innerHTML;
    }
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      return fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['.drawer__header', 'cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
          this.applySavedConfigurationGroupStates(document);
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      return fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
          this.applySavedConfigurationGroupStates(this);
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, event, name, variantId) {
    this.enableLoading(line);

    // Scroll-Position im Cart-Drawer speichern
    const cartDrawerWrapper = document.querySelector('cart-drawer');
    const scrollableContainer = cartDrawerWrapper ? cartDrawerWrapper.querySelector('cart-drawer-items') || cartDrawerWrapper.querySelector('.drawer__cart-items-wrapper') || cartDrawerWrapper.querySelector('.drawer__contents') : null;
    const savedScrollTop = scrollableContainer ? scrollableContainer.scrollTop : 0;

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });
    const eventTarget = event.currentTarget instanceof CartRemoveButton ? 'clear' : 'change';

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        CartPerformance.measure(`${eventTarget}:paint-updated-sections"`, () => {
          const quantityElement =
            document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
          const items = document.querySelectorAll('.cart-item');

          if (parsedState.errors) {
            quantityElement.value = quantityElement.getAttribute('value');
            this.updateLiveRegions(line, parsedState.errors);
            return;
          }

          this.classList.toggle('is-empty', parsedState.item_count === 0);
          const cartDrawerWrapper = document.querySelector('cart-drawer');
          const cartFooter = document.getElementById('main-cart-footer');

          if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
          if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

          this.getSectionsToRender().forEach((section) => {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          });
          const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
          let message = '';
          if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
            if (typeof updatedValue === 'undefined') {
              message = window.cartStrings.error;
            } else {
              message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
            }
          }
          this.updateLiveRegions(line, message);

          // Scroll-Container nach dem Update erneut suchen (kann neu erstellt worden sein)
          const updatedCartDrawerWrapper = document.querySelector('cart-drawer');
          const updatedScrollableContainer = updatedCartDrawerWrapper ? updatedCartDrawerWrapper.querySelector('cart-drawer-items') || updatedCartDrawerWrapper.querySelector('.drawer__cart-items-wrapper') || updatedCartDrawerWrapper.querySelector('.drawer__contents') : null;

          // Scroll-Position wiederherstellen, bevor Focus gesetzt wird
          if (updatedScrollableContainer && savedScrollTop !== undefined) {
            updatedScrollableContainer.scrollTop = savedScrollTop;
          }

          const lineItem =
            document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
          if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
            const inputElement = lineItem.querySelector(`[name="${name}"]`);
            if (cartDrawerWrapper) {
              // Focus ohne Scroll setzen
              if (inputElement && typeof inputElement.focus === 'function') {
                inputElement.focus({ preventScroll: true });
              }
              trapFocus(cartDrawerWrapper, inputElement);
            } else {
              inputElement.focus({ preventScroll: true });
            }
          } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper, cartDrawerWrapper.querySelector('.drawer__close') || cartDrawerWrapper.querySelector('a'));
          } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
            const firstCartItemName = document.querySelector('.cart-item__name');
            if (firstCartItemName) {
              firstCartItemName.focus({ preventScroll: true });
            }
            trapFocus(cartDrawerWrapper, firstCartItemName);
          }

          // Scroll-Position erneut wiederherstellen nach Focus (für den Fall, dass Focus doch gescrollt hat)
          if (updatedScrollableContainer && savedScrollTop !== undefined) {
            // Kurz verzögern, um sicherzustellen, dass alle Layout-Updates abgeschlossen sind
            requestAnimationFrame(() => {
              const finalScrollableContainer = updatedCartDrawerWrapper ? updatedCartDrawerWrapper.querySelector('cart-drawer-items') || updatedCartDrawerWrapper.querySelector('.drawer__cart-items-wrapper') || updatedCartDrawerWrapper.querySelector('.drawer__contents') : null;
              if (finalScrollableContainer) {
                finalScrollableContainer.scrollTop = savedScrollTop;
              }
            });
          }
        });

        CartPerformance.measureFromEvent(`${eventTarget}:user-action`, event);

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });

        if (typeof window.syncKonfiguratorOrderNote === 'function') {
          window.syncKonfiguratorOrderNote();
        }
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
              .then(() => CartPerformance.measureFromEvent('note-update:user-action', event));
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
